import type { SxProps, Theme } from "@mui/material/styles";
import {
  PRIMARY_COLOR,
  TEXT_SECONDARY,
  SIDE_PADDING,
  MAX_WIDTH,
} from "../../theme/consts";

export const interestWidgetContainerSx: SxProps<Theme> = {
  position: "fixed",
  right: {
    xs: "0.5rem",
    md: `2rem`,
    "2xl": `3rem`,
  },
  top: { xs: "auto", md: "10rem" },
  bottom: { xs: "3rem", md: "auto" },
  zIndex: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const interestWidgetSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": {
    "& .interest-widget-label": {
      width: "auto",
      paddingLeft: "1rem",
      paddingRight: "1.75rem",
      opacity: 1,
    },
  },
};

export const interestWidgetLabelSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  height: "2rem",
  width: 0,
  paddingLeft: 0,
  paddingRight: 0,
  opacity: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
  backgroundColor: "#D9D9D9E6",
  backdropFilter: "blur(18px)",
  border: "1px solid #FFFFFF",
  borderRight: "none",
  borderRadius: "1.1875rem 0 0 1.1875rem",
  transition: "all 0.3s ease-in-out",
  marginRight: "-1.25rem",
  zIndex: 1,
};

export const interestWidgetTextSx: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontWeight: 400,
  fontSize: "1.25rem",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: TEXT_SECONDARY,
  whiteSpace: "nowrap",
};

export const interestWidgetIconWrapperSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "2.5rem",
  height: "2.5rem",
  borderRadius: "50%",
  backgroundColor: PRIMARY_COLOR,
  flexShrink: 0,
  zIndex: 2,
  position: "relative",
};

export const interestWidgetIconSx: SxProps<Theme> = {
  width: "1.25rem",
  height: "1.25rem",
  "& path": {
    fill: "#FFFFFF",
  },
};
